export default "__VITE_ASSET__3f0ee9a0__"